import { cn } from '#client/lib/cn';

interface ProgressProps {
  entered: number;
  total: number;
}

/**
 * "6/8" with a bar behind it — how far through a report's results someone is.
 *
 * The count and the bar together rather than either alone: the bar is scannable
 * down a column, the numbers are exact, and the title attribute spells it out
 * for anyone who needs the words.
 *
 * Takes plain counts; `reportProgress` in shared decides what counts.
 */
export function Progress({ entered, total }: ProgressProps) {
  const complete = total > 0 && entered === total;
  const percent = total === 0 ? 0 : Math.round((entered / total) * 100);

  return (
    <span
      className={cn('c-progress', complete && 'c-progress--complete')}
      title={`${entered} of ${total} results entered`}
    >
      <span className="c-progress__track">
        <span className="c-progress__fill" style={{ inlineSize: `${percent}%` }} />
      </span>
      {entered}/{total}
    </span>
  );
}
